"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kSample = void 0;
var tf = require('@tensorflow/tfjs-core');
const irt_1 = require("./irt");
/**
 *
 * @param k : number of elements to choose
 * @param a
 * @returns list of k randomly chosen elements in a
 */
let choice = (k, a) => {
    var remaining = Array.from(a);
    const res = [];
    for (let i = 0; i < k; i++) {
        var index = Math.floor(Math.random() * remaining.length);
        var randomElement = remaining[index];
        res.push(randomElement);
        remaining.splice(index, 1);
    }
    return res;
};
/**
 *
 * @param items : list of all items available in the bank
 * @param L : symmetric positive definite matrix. L = A * A^T with A the discrimination matrix (lines are the
 * discriminations of each items in the bank)
 * @param k : number of elements to sample
 * @param maxNbIter : number of iterations of the process
 * @returns k elements randomly sampled from L according to a determinental point process
 */
let kSample = (items, L, k, maxNbIter = 100) => {
    if (items.length <= k) {
        return items;
    }
    const range = new Array(items.length).keys();
    const initial = choice(k, Array.from(range)); // liste de k questions choisies arbitrairement
    var X = new Array(items.length).fill(false);
    for (let i = 0; i < k; i++) {
        X[initial[i]] = true;
    }
    for (let j = 0; j < maxNbIter; j++) {
        const uArray = [];
        const vArray = [];
        for (let i = 0; i < X.length; i++) {
            if (X[i]) {
                uArray.push(i);
            }
            else {
                vArray.push(i);
            }
        }
        const u = uArray[Math.floor(Math.random() * uArray.length)];
        const v = vArray[Math.floor(Math.random() * vArray.length)];
        const Y = Array.from(X);
        Y[u] = false;
        const L_Y = [];
        const b_u = [];
        const b_v = [];
        for (let ii = 0; ii < Y.length; ii++) {
            var row_L = [];
            var row_u = [];
            var row_v = [];
            if (Y[ii]) {
                row_u.push(L[ii][u]);
                row_v.push(L[ii][v]);
                for (let jj = 0; jj < Y.length; jj++) {
                    if (Y[jj]) {
                        row_L.push(L[ii][jj]);
                    }
                }
                L_Y.push(row_L);
                b_u.push(row_u);
                b_v.push(row_v);
            }
        }
        const L_Y_inv = (0, irt_1.inverseMatrix)(tf.tensor(L_Y)).arraySync();
        if (L_Y_inv == 0) {
            return 0;
        }
        var c_v = L[v][v];
        var c_u = L[u][u];
        var p = Math.min(1, c_v - tf.dot(tf.dot(tf.transpose(b_v), L_Y_inv), b_v).dataSync()[0] / (c_u - tf.dot(tf.dot(tf.transpose(b_u), tf.transpose(L_Y_inv)), b_u).dataSync()[0]));
        if (Math.random() < p) {
            X = Array.from(Y);
            X[v] = true;
        }
    }
    const res = [];
    for (let i = 0; i < items.length; i++) {
        if (X[i]) {
            res.push(items[i]);
        }
    }
    return res;
};
exports.kSample = kSample;
